<app-top>
  <h1>Hoppsan!</h1>
  <h2>Sidan du söker finns inte längre (404)</h2>
  <p>Uppmärksamma oss om vilken webbplats som har den felaktiga länken genom att skicka ett meddelande till oss.</p>
</app-top>
